import { useEffect, useState } from 'react';
import { Snow, Snowflake1, Snowflake2, Snowflake3, Snowflake4, Snowflake5, Snowflake6, Snowflake7, Snowflake8, Snowflake9, Snowflake10, Snowflake11, Snowflake12, Snowflake13, Snowflake14, Snowflake15, Snowflake16, Snowflake17, Snowflake18, Snowflake19, Snowflake20, NoOverflow } from '../themes/theme'
import BackgroundClouds from './BackgroundClouds';

export default function BackgroundSnow() {

  return (
      <Snow>
          <NoOverflow>
            <Snowflake1 width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="42" cy="42" r="42" fill="url(#paint0_radial_18_356)"/>
            <defs>
              <radialGradient id="paint0_radial_18_356" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(42 42) rotate(90) scale(42)">
              <stop stop-color="white"/>
              <stop offset="1" stop-color="white" stop-opacity="0"/>
              </radialGradient>
            </defs>
            </Snowflake1>
            <Snowflake2 width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="42" cy="42" r="42" fill="url(#paint0_radial_18_356)"/>
            <defs>
              <radialGradient id="paint0_radial_18_356" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(42 42) rotate(90) scale(42)">
              <stop stop-color="white"/>
              <stop offset="1" stop-color="white" stop-opacity="0"/>
              </radialGradient>
            </defs>
            </Snowflake2>
            <Snowflake3 width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="42" cy="42" r="42" fill="url(#paint0_radial_18_356)"/>
            <defs>
              <radialGradient id="paint0_radial_18_356" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(42 42) rotate(90) scale(42)">
              <stop stop-color="white"/>
              <stop offset="1" stop-color="white" stop-opacity="0"/>
              </radialGradient>
            </defs>
            </Snowflake3>
            <Snowflake4 width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="42" cy="42" r="42" fill="url(#paint0_radial_18_356)"/>
            <defs>
              <radialGradient id="paint0_radial_18_356" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(42 42) rotate(90) scale(42)">
              <stop stop-color="white"/>
              <stop offset="1" stop-color="white" stop-opacity="0"/>
              </radialGradient>
            </defs>
            </Snowflake4>
            <Snowflake5 width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="42" cy="42" r="42" fill="url(#paint0_radial_18_356)"/>
            <defs>
              <radialGradient id="paint0_radial_18_356" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(42 42) rotate(90) scale(42)">
              <stop stop-color="white"/>
              <stop offset="1" stop-color="white" stop-opacity="0"/>
              </radialGradient>
            </defs>
            </Snowflake5>
            <Snowflake6 width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="27" cy="27" r="27" fill="url(#paint0_radial_18_359)"/>
              <defs>
                <radialGradient id="paint0_radial_18_359" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(27 27) rotate(90) scale(27)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake6>
            <Snowflake7 width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="27" cy="27" r="27" fill="url(#paint0_radial_18_359)"/>
              <defs>
                <radialGradient id="paint0_radial_18_359" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(27 27) rotate(90) scale(27)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake7>
            <Snowflake8 width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="27" cy="27" r="27" fill="url(#paint0_radial_18_359)"/>
              <defs>
                <radialGradient id="paint0_radial_18_359" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(27 27) rotate(90) scale(27)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake8>
            <Snowflake9 width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21" cy="21" r="21" fill="url(#paint0_radial_18_362)"/>
              <defs>
                <radialGradient id="paint0_radial_18_362" cx="0" cy="0" r="1"   gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) rotate(90) scale(21)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake9>
            <Snowflake10 width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21" cy="21" r="21" fill="url(#paint0_radial_18_362)"/>
              <defs>
                <radialGradient id="paint0_radial_18_362" cx="0" cy="0" r="1"   gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) rotate(90) scale(21)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake10>
            <Snowflake11 width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21" cy="21" r="21" fill="url(#paint0_radial_18_362)"/>
              <defs>
                <radialGradient id="paint0_radial_18_362" cx="0" cy="0" r="1"   gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) rotate(90) scale(21)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake11>
            <Snowflake12 width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21" cy="21" r="21" fill="url(#paint0_radial_18_362)"/>
              <defs>
                <radialGradient id="paint0_radial_18_362" cx="0" cy="0" r="1"   gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) rotate(90) scale(21)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake12>
            <Snowflake13 width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21" cy="21" r="21" fill="url(#paint0_radial_18_362)"/>
              <defs>
                <radialGradient id="paint0_radial_18_362" cx="0" cy="0" r="1"   gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) rotate(90) scale(21)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake13>
            <Snowflake14 width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="27" cy="27" r="27" fill="url(#paint0_radial_18_359)"/>
              <defs>
                <radialGradient id="paint0_radial_18_359" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(27 27) rotate(90) scale(27)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake14>
            <Snowflake15 width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="27" cy="27" r="27" fill="url(#paint0_radial_18_359)"/>
              <defs>
                <radialGradient id="paint0_radial_18_359" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(27 27) rotate(90) scale(27)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake15>
            <Snowflake16 width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="42" cy="42" r="42" fill="url(#paint0_radial_18_356)"/>
            <defs>
              <radialGradient id="paint0_radial_18_356" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(42 42) rotate(90) scale(42)">
              <stop stop-color="white"/>
              <stop offset="1" stop-color="white" stop-opacity="0"/>
              </radialGradient>
            </defs>
            </Snowflake16>
            <Snowflake17 width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21" cy="21" r="21" fill="url(#paint0_radial_18_362)"/>
              <defs>
                <radialGradient id="paint0_radial_18_362" cx="0" cy="0" r="1"   gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) rotate(90) scale(21)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake17>
            <Snowflake18 width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21" cy="21" r="21" fill="url(#paint0_radial_18_362)"/>
              <defs>
                <radialGradient id="paint0_radial_18_362" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) rotate(90) scale(21)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake18>
            <Snowflake19 width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21" cy="21" r="21" fill="url(#paint0_radial_18_362)"/>
              <defs>
                <radialGradient id="paint0_radial_18_362" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) rotate(90) scale(21)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake19>
            <Snowflake20 width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="21" cy="21" r="21" fill="url(#paint0_radial_18_362)"/>
              <defs>
                <radialGradient id="paint0_radial_18_362" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) rotate(90) scale(21)">
                  <stop stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </radialGradient>
              </defs>
            </Snowflake20>
        </NoOverflow>
      </Snow>
  );
}